module.exports = __webpack_public_path__ + "static/media/404.24525eca.png";